(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/lb-ui/drawer/assets/javascripts/prescript.js') >= 0) return;  svs.modules.push('/components/lb-ui/drawer/assets/javascripts/prescript.js');

'use strict';

svs.components = svs.components || {};
svs.components.lbUi = svs.components.lbUi || {};


 })(window);